import React from 'react'
import { Switch, Route } from '@fs/zion-router'
import { LayoutBand, Grid, colors, Card, Bleed, useContainerWidth } from '@fs/zion-ui'
import EditorHandbookHeader from './components/EditorHandbookHeader'
import EditorHandbookNav from './components/EditorHandbookNav'
import EditorHandbookContent from './components/EditorHandbookContent'
import PlaceEditorTrainingPage from '../PlaceEditorTrainingPage/PlaceEditorTrainingPage'

// Markdown file paths served via getHandbookMarkdown endpoint
const landingPage = '/place-reports/handbook-content/landing_page.md'
const missionAndPurpose = '/place-reports/handbook-content/mission_and_purpose.md'
const creatingNewEntry = '/place-reports/handbook-content/creating_a_new_entry.md'
const deletingEntries = '/place-reports/handbook-content/deleting_entries.md'
const faqs = '/place-reports/handbook-content/faqs.md'

// Place-related fields
const certificationStatus = '/place-reports/handbook-content/certification_status.md'
const placeTypes = '/place-reports/handbook-content/place_types.md'
const placeNames = '/place-reports/handbook-content/place_names.md'
const parents = '/place-reports/handbook-content/parents.md'
const relatedPlaces = '/place-reports/handbook-content/related_places.md'

// Historical information
const historicalInformation = '/place-reports/handbook-content/historical_information.md'
const historicalPeriods = '/place-reports/handbook-content/historical_periods.md'

// Other fields
const nativeLanguageYearsLocation = '/place-reports/handbook-content/native_language_years_location.md'
const notes = '/place-reports/handbook-content/notes.md'
const researchLinksCitations = '/place-reports/handbook-content/research_links_citations.md'

function EditorHandbook() {
  const atWidth = useContainerWidth()
  const leftNavPanelColumns = atWidth({ default: 12, xl: 3 })
  const rightContentColumns = atWidth({ default: 12, xl: 9 })

  return (
    <div style={{ height: '100%' }}>
      <Grid gutters="xxs">
        <Card columns={12} margins="dense">
          <EditorHandbookHeader />
        </Card>
        <Card columns={leftNavPanelColumns} margins="dense">
          <Bleed top>
            <EditorHandbookNav />
          </Bleed>
        </Card>
        <Card columns={rightContentColumns} margins="dense">
          <Bleed top>
            <Switch>
              <Route exact path="/editor-handbook/">
                <EditorHandbookContent content={landingPage} />
              </Route>
              <Route exact path="/editor-handbook/mission-and-purpose/">
                <EditorHandbookContent content={missionAndPurpose} />
              </Route>
              <Route exact path="/editor-handbook/general-info/creating-new-entry/">
                <EditorHandbookContent content={creatingNewEntry} />
              </Route>
              <Route exact path="/editor-handbook/general-info/deleting-entries/">
                <EditorHandbookContent content={deletingEntries} />
              </Route>
              <Route exact path="/editor-handbook/faqs/">
                <EditorHandbookContent content={faqs} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/certification-status/">
                <EditorHandbookContent content={certificationStatus} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/place-types/">
                <EditorHandbookContent content={placeTypes} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/place-names/">
                <EditorHandbookContent content={placeNames} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/parents/">
                <EditorHandbookContent content={parents} />
              </Route>
              <Route exact path="/editor-handbook/place-fields/related-places/">
                <EditorHandbookContent content={relatedPlaces} />
              </Route>
              <Route exact path="/editor-handbook/historical/historical-information/">
                <EditorHandbookContent content={historicalInformation} />
              </Route>
              <Route exact path="/editor-handbook/historical/historical-periods/">
                <EditorHandbookContent content={historicalPeriods} />
              </Route>
              <Route exact path="/editor-handbook/other-fields/native-language-years-location/">
                <EditorHandbookContent content={nativeLanguageYearsLocation} />
              </Route>
              <Route exact path="/editor-handbook/other-fields/notes/">
                <EditorHandbookContent content={notes} />
              </Route>
              <Route exact path="/editor-handbook/other-fields/research-links-citations/">
                <EditorHandbookContent content={researchLinksCitations} />
              </Route>
            </Switch>
          </Bleed>
        </Card>
      </Grid>
    </div>
  )
}

export default function EditorHandbookPage() {
  return (
    <Switch>
      <Route path="/editor-handbook/training/">
        <PlaceEditorTrainingPage />
      </Route>
      <Route path="/editor-handbook/">
        <LayoutBand
          maxWidth="xxl"
          marginY="nano"
          marginX="nano"
          style={{ height: 'calc(100vh - 70px)', background: colors.gray02 }}
        >
          <EditorHandbook />
        </LayoutBand>
      </Route>
    </Switch>
  )
}
